import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import type { Auth } from 'app/typings/auth';
import { decodeToken } from 'app/utils/decodeJWT';
import { removeUserCookie, setUserCookie } from 'app/utils/request/api';

export function useAuth(appUrl?: string) {
  const { data: token } = useQuery({
    queryKey: [`${appUrl}/auth`],
    queryFn: appUrl
      ? async () => {
          try {
            const response = await axios.get(`${appUrl}/auth`, {
              withCredentials: true,
              headers: {
                'Cache-Control': 'no-store',
              },
            });

            return response.data;
          } catch (err) {
            removeUserCookie();

            const currentUrl = window.location.href;

            window.location.replace(
              `${appUrl}/fr?login=true&next=${currentUrl}`
            );
          }
        }
      : undefined,
    enabled: !!appUrl,
  });

  if (token) {
    const decodedToken = decodeToken(token) as Auth;

    setUserCookie(decodedToken.token);

    return decodedToken;
  }

  return { user: null, token: null };
}
